import { atom } from 'recoil';
import type { OPCReceiptPageChangeType } from '../types/opcTypes';

export const getOPCReceiptPageChangeTypeAtom = atom<OPCReceiptPageChangeType | undefined>({
    key: 'getOPCReceiptPageChangeType',
    default: undefined
});
